import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "m-3 d-flex justify-content-end" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "alert bg-light-danger d-flex align-items-center p-5"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-radioactive fs-2" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-1 text-dark" }, "Every Fields should be unique"),
  /*#__PURE__*/_createElementVNode("span", null, "Make Sure that there is at least one diffrent between fields")
], -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "alert bg-light-danger d-flex align-items-center p-5"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-1 text-dark" }, "All Fields are required")
], -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "col-md-3 fv-row" }
const _hoisted_35 = {
  key: 0,
  class: "col-lg-12 col-form-label required fw-bold fs-6"
}
const _hoisted_36 = { class: "col-lg-10 fv-row" }
const _hoisted_37 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "col-md-3 fv-row" }
const _hoisted_42 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_43 = { class: "col-lg-10 fv-row" }
const _hoisted_44 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "col-md-3 fv-row" }
const _hoisted_47 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_48 = { class: "col-lg-10 fv-row" }
const _hoisted_49 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "col-md-3 fv-row" }
const _hoisted_52 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-10 fv-row" }
const _hoisted_54 = { class: "col-md-3 fv-row" }
const _hoisted_55 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-10 fv-row" }
const _hoisted_57 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_58 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_59 = { class: "indicator-label" }
const _hoisted_60 = { class: "indicator-progress" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'instant-rent-estimator'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewIreStreet')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.ireStreetSchema
          }, {
            default: _withCtx(({ values }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('streets')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      requierd: true,
                      label: "areaName",
                      trackBy: "areaName",
                      searchable: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      placeholder: _ctx.translate('selectAreas'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound')
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('titleEn')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('titleEn')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('titleAr')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('titleAr')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('sort')), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "sort",
                      min: "1",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('sort'),
                      "onUpdate:modelValue": ($event: any) => (values.sort = Number(values.sort))
                    }, null, 8, ["placeholder", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_ErrorMessage, { name: "sort" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-5 border-top p-3",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-active-light-primary me-2",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewField && _ctx.addNewField(...args)))
                        }, _toDisplayString(_ctx.translate('addNewField')), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-light-danger btn-active-light-primary me-2",
                          onClick: ($event: any) => (_ctx.removeField(index))
                        }, _toDisplayString(_ctx.translate('remove')), 9, _hoisted_26)
                      ]),
                      (
                  _ctx.dublicatedError.isActive && index === _ctx.dublicatedError.index
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
                        : _createCommentVNode("", true),
                      (
                  _ctx.requierdFieldError.isActive &&
                  index === _ctx.requierdFieldError.index
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.propertyTypes && _ctx.propertyTypes.length > 0)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_35, _toDisplayString(_ctx.translate('propertyTypes')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: 'propertyType_' + index,
                            class: "form-select form-select-solid form-select-lg text-capitalize",
                            modelValue: field.propertyTypeId,
                            "onUpdate:modelValue": ($event: any) => ((field.propertyTypeId) = $event),
                            rules: "required",
                            onChange: ($event: any) => (_ctx.handleSelectedPropertyType(index))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.translate('selectePropertyCategory')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypes, (propertyType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: propertyType.id,
                                  value: propertyType.id
                                }, _toDisplayString(propertyType.titleAr), 9, _hoisted_38))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["name", "modelValue", "onUpdate:modelValue", "onChange"]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_ErrorMessage, {
                                name: `propertyTypeId_${index}`
                              }, null, 8, ["name"])
                            ])
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate('floorTypes')), 1),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: 'floorTypeId' + index,
                            class: "form-select form-select-solid form-select-lg text-capitalize",
                            modelValue: field.floorTypeId,
                            "onUpdate:modelValue": ($event: any) => ((field.floorTypeId) = $event),
                            onChange: ($event: any) => (_ctx.handleSelectedFloorTypeId(index))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.translate('selectFloorType')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.floorTypes[index], (floorType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: floorType.id,
                                  value: floorType.id
                                }, _toDisplayString(floorType.titleAr), 9, _hoisted_45))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["name", "modelValue", "onUpdate:modelValue", "onChange"])
                        ])
                      ], 512), [
                        [_vShow, field.propertyTypeId > 0]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_46, [
                        _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('direction')), 1),
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: 'direction' + index,
                            class: "form-select form-select-solid form-select-lg text-capitalize",
                            modelValue: field.directionId,
                            "onUpdate:modelValue": ($event: any) => ((field.directionId) = $event)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.translate('direction')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.direction[index], (floorType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: floorType.id,
                                  value: floorType.id
                                }, _toDisplayString(floorType.titleAr), 9, _hoisted_50))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                        ])
                      ], 512), [
                        [_vShow, field.floorTypeId > 0]
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.translate('value')), 1),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_Field, {
                            type: "number",
                            min: "1",
                            name: 'value' + index,
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.translate('decreasePercentage')), 1),
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_Field, {
                            type: "number",
                            min: "1",
                            name: 'decreasePercentage' + index,
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: field.decreasePercentage,
                            "onUpdate:modelValue": ($event: any) => ((field.decreasePercentage) = $event)
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (!_ctx.createdStreet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("button", {
                      type: "reset",
                      class: "btn btn-white btn-active-light-primary me-2",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, _toDisplayString(_ctx.translate('discard')), 1),
                    _createElementVNode("button", _hoisted_58, [
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_60, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_61
                      ])
                    ], 512)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}